import _ from 'lodash';
import React, { Fragment, useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu } from "reactstrap";
import { useGetPOETAByItemNumber } from "../hooks";
import { api, constants, dateHelpers } from "../utils";
import { toast } from "react-toastify";

export default function PORawMaterialDropDown(props) {
  // eslint-disable-next-line no-unused-vars
  const [InTransitPoz, OnOrderPoz, isLoadingHook] = useGetPOETAByItemNumber(props.itemNumber);
  const [open, setOpen] = useState(false);

  function printPo(poNumber) {
    api
      .postDownloadBinary(
        `Report/PODetailReport/${poNumber}`,
        {},
        constants.MIME_TYPES.pdf,
        `PO_${poNumber}_${dateHelpers.toLongDateString(
          Date.now()
        )}_Report.pdf`
      ).then((res) => {
        if(res?.data === false) {
          toast.error(res.message);
        }
      })
      .catch(api.catchHandler);
  }

  return (
    <td
      className="data-cell"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      style={{ position: "relative" }}
    >
      <span className="shredLink fw-bold">{Math.round(props.rawTotalOrdered).toLocaleString()}</span>
      <Dropdown
        isOpen={open}
        toggle={() => setOpen(!open)}
        style={{ position: "absolute", top: "1.75em", left: "2em" }}
      >
        {!OnOrderPoz.length ? (
          <DropdownMenu>
            <DropdownItem
            className="sort-handle"
            >No Open PO Found</DropdownItem>
          </DropdownMenu>
        ) : (
          <DropdownMenu>
            {_.map(OnOrderPoz, (datum, index) => {
              return (
                <Fragment key={index}>
                  <DropdownItem className="sort-handle" onClick={() => printPo(datum.poNumber)}>
                    {`${datum.poNumber} ${Math.round(datum.orderQty).toLocaleString()} ETA:${dateHelpers.toLongDateString(datum.promisedDate)}`}
                  </DropdownItem>
                </Fragment>
              );
            })}
          </DropdownMenu>
        )}
      </Dropdown>
    </td>
  );
}
